module.exports = __webpack_public_path__ + "a271b9db3250226a2eb791bd2064b1df.png";